<app-loader *ngIf="loginCarg"></app-loader>
<div class="modal-content2">
  <div class="modal-header">
    <span class="close" (click)="onNo()">
      <fa-icon [icon]="faChevronLeft"></fa-icon>
    </span>
    <h5 class="modal-title" *ngIf="!correoEnviado">{{ title }}</h5>
  </div>

  <div class="modal-body">
    <form *ngIf="!correoEnviado" [formGroup]="confirmAccount">
      <h2>
        {{ msg }}
      </h2>

      <div class="form-group form-container">
        <app-input-text
          #firstInput
          type="number"
          placeholder="0"
          frmControl="firstCode"
          class_label="white"
          [formParent]="confirmAccount"
          class="input-code"
          (input)="moveFocus($event, secondInput, null, 'firstCode')"
          (keydown)="handleKeyDown($event, secondInput, null, 'firstCode')"
          (paste)="handlePaste($event)"
        ></app-input-text>
        <app-input-text
          #secondInput
          type="number"
          placeholder="0"
          frmControl="secondCode"
          class_label="white"
          [formParent]="confirmAccount"
          class="input-code"
          (input)="moveFocus($event, thirdInput, firstInput, 'secondCode')"
          (keydown)="handleKeyDown($event, thirdInput, firstInput, 'secondCode')"
          (paste)="handlePaste($event)"
        ></app-input-text>
        <app-input-text
          #thirdInput
          type="number"
          placeholder="0"
          frmControl="thirdCode"
          class_label="white"
          [formParent]="confirmAccount"
          class="input-code"
          (input)="moveFocus($event, fourthInput, secondInput, 'thirdCode')"
          (keydown)="handleKeyDown($event, fourthInput, secondInput, 'thirdCode')"
          (paste)="handlePaste($event)"
        ></app-input-text>
        <app-input-text
          #fourthInput
          type="number"
          placeholder="0"
          frmControl="fourthCode"
          class_label="white"
          [formParent]="confirmAccount"
          class="input-code"
          (input)="moveFocus($event, null, thirdInput, 'fourthCode')"
          (keydown)="handleKeyDown($event, null, thirdInput, 'fourthCode')"
          (paste)="handlePaste($event)"
        ></app-input-text>
    </div>

      <p *ngIf="confirmAccount.invalid && confirmAccount.dirty" class = "mandatory-field mt-2">Este campo es obligatorio.</p>

      <button
        type="submit"
        class="btn btn-primary btn-block mt-4"
        (click)="verifyAccount()"
        [disabled]="!confirmAccount.valid"
      >
        Continuar
      </button>
      <div class="text-center mt-3">
        <a 
          class="btn-resend" 
          [ngClass]="{ active: isCounterCompleted || !isCounterActive }" 
          (click)="(isCounterCompleted || !isCounterActive) ? resendOTP() : null"
          #btnResend
        >
          <span *ngIf="!(isCounterCompleted || !isCounterActive); else showResend">
            Podrás reenviar el código en {{ remainingTime }} s.
          </span>
          
          <ng-template #showResend>
            Reenviar código
          </ng-template>
        </a>
      </div>
      <span></span>

    </form>

    <div *ngIf="correoEnviado" class="popup-exito">
      <div class="popup-content">
        <div class="icono-exito">
          <img
            src="assets/icons/success.svg"
            alt="Éxito"
            width="80"
            height="80"
          />
        </div>
        <h2>Recuperar contraseña</h2>
        <p>
          hemos enviado un correo electrónico a {{email}} con el enlace para restablecer tu contraseña.
        </p>

        <p>
          <span style="font-weight: 600;">Nota:</span> Revisa la bandeja  de entrada y la carpeta de spam. Si no llega en los próximos 2 minutos, puedes solicitar un nuevo envio.
        </p>
        <button
          class="btn btn-primary"
          [disabled]="!puedeReenviar"
          (click)="resend()"
        >
          {{
            puedeReenviar
              ? "Reenviar correo"
              : "Reenviar en " + tiempoRestante + "s"
          }}
        </button>
      </div>
    </div>
  </div>
</div>
